/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { EMailData, EmailService, Status } from 'src/refresh/service/email-service';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { ORGContactInformationValidation } from './ORG_contact_information.validator';
import { ItemList } from '../_common/constant/item-list';
import { IValidator } from '../_common/component/IValidator';

@Component({ 
      selector: 'ORG_contact_information',
      templateUrl: './ORG_contact_information.component.html',
      styleUrls: ['./ORG_contact_information.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class ORGContactInformationComponent implements OnInit {  // extends FormBaseComponent 

      public validator:IValidator;
      
      public userEmail:string = '';
      public userMessage:string = '';
      public subject:string = '';
      
      public submitted:boolean = false;
      
      public error_email:string = '';
      public error_message:string = '';
      public error_subject:string = '';
      public error_sent:string = '';

      constructor( protected router: Router ,
                   public timerService:TimerService,
                   public items:ItemList,
                   public emailService:EmailService, 
                   public data:InputData ) {

                   //super(router,timerService);  
                   this.validator = new ORGContactInformationValidation(this);
                   window.scrollTo(0, 0);

                   window.onpopstate = null;
       }

       public ngOnInit() {
       }
       
       public onPreviousClick() {
              window.history.back();
       }

       public sendMessage() {
            //validate first
            if ( this.validator.validate() ){
                  this.error_message = '';
                  this.error_sent = "";
                  
                  //send message by email                  
                  let emailData:EMailData = new EMailData();
                  
                  emailData.content = 'Email Address: ' + this.userEmail + '\n\n' + this.userMessage;
                  emailData.type = parseInt(this.subject);

                  if ( this.data.subject.language == 'fr' ) {
                       emailData.type = -emailData.type;
                  }
                  
                  let that = this;
                  this.emailService.send(emailData, function(status:Status) { 

                              ///console.log(status);  
                              if ( status.success  )
                                   that.submitted = true;
                              else that.error_sent = 'ORG_contact_information.sentError';
                  });
            }
       }
       
       public messageChanged(){
            this.error_message = '';
            this.submitted = false;
       }
}